import { IDemo, E3DDemoNameVals } from '../../types'

export const ybvr: IDemo = {
  type: 'ybvr',
  intro: 'YBVR-intro_720.mp4',
  video: 'YBVR_v6_EMEA.mp4',
  conversationId: 'd1a80a79-6524-4ece-9860-85d48338b520',
  end: {
    header: 'Transforming the fan experience',
    body:
      'YBVR tests how they can utilise Verizon 5G Edge to stream live 8K video to sports fans and concert-goers, allowing simultaneous users to choose various camera views with super-low latency.',
    qr: '',
    expert: '',
    nextDemoText: 'The transformation of healthcare.',
    nextDemo: E3DDemoNameVals.avesha,
    nextDemoThumbnail: 'avesha-thumbnail.png'
  }
}
